<template>
  <div class="c-action-interest">
    <div v-show="action" class="c-action-line">
      <span>在</span>
      <el-select
        v-model="action_scene"
        multiple
        collapse-tags
        :popper-append-to-body="false"
        placeholder="所有行为场景"
        style="width: 220px"
      >
        <el-option v-for="scene in scenes" :key="scene.key" :value="scene.key" :label="scene.label"> </el-option>
      </el-select>
      <span>中，选择用户</span>
      <el-select v-model="action_days" :popper-append-to-body="false" style="width: 80px">
        <el-option v-for="day in days" :key="day" :value="day" :label="`${day}天`"> </el-option>
      </el-select>
      <span>内发生的行为：</span>
    </div>
    <div class="c-action-content">
      <Row>
        <Col span="16" class-name="c-action-category">
          <Tabs v-model="tagType" :animated="false">
            <TabPane label="添加类目词" name="category">
              <category-select
                v-model="mult_category"
                :loading="loading"
                :data="categories"
                :recommons="recommons"
                :words="words"
                :query-word="queryWord"
                :complete-data="autoData"
                :placeholder="categoryPlaceholder"
                :disabled="disabled"
                @on-more="handleMore"
                @on-complete="searchCategory"
                @on-search="queryRecommon"
                @on-select="selectKeyword"
                @on-clear="recommons = []"
                @on-cancel="cannelHandle"
              />
            </TabPane>
            <TabPane label="添加关鍵词" name="keyword">
              <keyword-select
                v-model="keyword"
                :data="keywords"
                :words="words"
                :complete-data="completeData"
                :loading="quering"
                :placeholder="queryPlaceholder"
                :disabled="disabled"
                @on-complete="searchKeyword"
                @on-search="queryKeyword"
                @on-select="selectKeyword"
                @on-cancel="cannelHandle"
              />
            </TabPane>
            <div slot="extra">
              <p :style="{ lineHeight: '50px', paddingRight: '10px', display: 'inline-block' }">使用账号：{{ userAccount }}</p>
              <Button :style="{ marginRight: '8px' }" @click="uploadBetch">批量添加</Button>
            </div>
          </Tabs>
        </Col>
        <Col span="7" offset="1">
          <action-result
            :value="actions"
            :title="tagName"
            :loading="loading"
            :max="max"
            sub-title
            @on-search="queryKeyword"
            @on-delete="delTag"
            @on-clear="clearTag"
          />
        </Col>
      </Row>
    </div>

    <!-- 批量导入 -->
    <betch-import
      v-model="betchModel"
      :data="betchSource"
      :account="account"
      :action="action"
      :max="max"
      :result="actions"
      @on-select="betchAddWords"
    />
  </div>
</template>
<script>
import { isArray, findCheck, getKeyOfData, clearTagOfData } from '@/common/js/utils'
import { DAYS, SCENE } from './data'
import {
  getActionCategory,
  getInterestCategory,
  getKeywordSuggest,
  getKeywordAction,
  getKeywordInterest,
  getCategoryAction,
  getCagegoryInterest
} from '@/api/toutiao.model'

import CategorySelect from './select/category'
import KeywordSelect from './select/keyword'
import ActionResult from './result/result'
import BetchImport from './select/betch-import'

// 子集
const findChild = (data) => {
  return data.reduce((childs, ret) => {
    childs.push(ret)
    if (ret.children) childs = childs.concat(findChild(ret.children))
    return childs
  }, [])
}

const concat = (array, sum) => {
  return array.reduce((arr, item) => {
    arr.push(item)
    if (isArray(item.children) && item.children.length) arr.concat(concat(item.children, arr))
    return arr
  }, sum)
}

// 所有子集
const getCheckId = (item, data) => {
  if (!isArray(item)) return []
  return item.reduce((ids, ret) => {
    const cat = findChild(data)
      .filter((m) => ret.id === m.id)
      .pop()
    ids.push(ret.id)
    if (ret.children) ids = ids.concat(getCheckId(ret.children, data))
    else if (cat && isArray(cat.children)) ids = ids.concat(getCheckId(cat.children, data))
    return ids
  }, [])
}
export default {
  name: 'actionInterest',
  components: {
    CategorySelect,
    KeywordSelect,
    ActionResult,
    BetchImport
  },
  props: {
    value: {
      type: Array
    },
    action: {
      type: Boolean
    },
    accounts: {
      type: Array
    },
    actionScene: {
      type: Array
    },
    actionDays: {
      type: Number
    },
    max: {
      type: Number
    }
  },
  computed: {
    action_days: {
      get() {
        return this.actionDays || 7
      },
      set(val) {
        this.$emit('on-days', val)
      }
    },
    action_scene: {
      get() {
        return this.actionScene || []
      },
      set(val) {
        this.$emit('on-scene', val)
      }
    },
    tagName() {
      return this.action ? '行为' : '兴趣'
    },
    categoryPlaceholder() {
      return `请输入${this.tagName}类目词`
    },
    queryPlaceholder() {
      return `请输入${this.tagName}类目词或关键词`
    },
    postActionScene() {
      return isArray(this.action_scene) && !this.action_scene.length
        ? this.scenes.map((ret) => ret.key).join(',')
        : this.action_scene.join(',')
    },
    account() {
      const accounts = isArray(this.accounts) ? JSON.parse(JSON.stringify(this.accounts.map((ret) => ret.id))) : [3232]
      return accounts.shift()
    },
    userAccount() {
      if (isArray(this.accounts) && this.accounts.length) {
        const { name } = this.accounts.filter((_) => 1).pop()
        return name
      } else return ''
    },
    mult_category() {
      return findCheck(this.categories)
    },
    actions() {
      const categoryActions = this.mult_category.map((ret) => Object.assign(ret, { type: 'CATEGORY', id: ret.key, name: ret.value }))
      const keywordActions = this.words.map((ret) => Object.assign(ret, { type: 'KEYWORD' }))
      // console.log(categoryActions, keywordActions)
      return [...keywordActions, ...categoryActions]
    },
    disabled() {
      return this.actions.length >= this.max
    }
  },
  methods: {
    proLoadData() {
      // 回调
      const fnCallback = (data) => {
        this.loading = true
        if (isArray(data)) {
          const defaultActions = isArray(this.value) && this.value.filter((ret) => ret.type.toLowerCase() === 'category') // 类目已选
          const defaultWords = isArray(this.value) && this.value.filter((ret) => ret.type.toLowerCase() === 'keyword') // 关键词
          const defaultActionIds = getCheckId(defaultActions, data) // 类目id
          const mapCategroy = (ret) => {
            // 初始化数据
            const checkState = defaultActionIds.includes(ret.id)
            const cate = {
              id: ret.id,
              key: ret.id,
              value: ret.name,
              name: ret.name,
              check: checkState,
              num: ret.num,
              type: ret.type,
              _time: ret._time
            }
            if (ret.children) {
              return Object.assign({}, cate, {
                children: ret.children.map(mapCategroy)
              })
            } else {
              return cate
            }
          }
          // 还原选中值
          this.categories = data.map(mapCategroy)
          this.words = defaultWords
        }
      }
      if (this.action) {
        // 行业类目查询
        let params = { ad_account_id: this.account }
        if (this.action) params = Object.assign(params, { action_days: this.action_days, action_scene: this.postActionScene })
        getActionCategory(params).then(fnCallback)
      } else getInterestCategory({ ad_account_id: this.account }).then(fnCallback)
    },
    queryKeyword(filter) {
      let params = {
        ad_account_id: this.account,
        targeting_type: this.action ? 'ACTION' : 'INTEREST'
      }
      if (this.action) params = Object.assign(params, { action_days: this.action_days, action_scene: this.postActionScene })
      if (this.tagType !== 'keyword') this.tagType = 'keyword'
      this.keyword = filter.name
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 开始请求关键词
      this.quering = true
      getKeywordSuggest(params).then((data) => {
        this.quering = false
        if (isArray(data)) {
          this.keywords = data
        }
      })
    },
    queryRecommon(filter) {
      let params = {
        ad_account_id: this.account,
        targeting_type: this.action ? 'ACTION' : 'INTEREST'
      }
      if (this.action) params = Object.assign(params, { action_days: this.action_days, action_scene: this.postActionScene })
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      getKeywordSuggest(params).then((data) => {
        if (data) {
          this.queryWord = this.params.name
          this.recommons = data
        }
      })
    },
    searchKeyword(query) {
      let params = {
        ad_account_id: this.account,
        query_words: query
      }
      const fnCallback = (data) => {
        isArray(data) && this.canning && (this.completeData = data)
      }
      this.canning = true
      if (this.action) {
        params = Object.assign(params, { action_days: this.action_days, action_scene: this.postActionScene })
        getKeywordAction(params).then(fnCallback)
      } else getKeywordInterest(params).then(fnCallback)
    },
    searchCategory(query) {
      let params = {
        ad_account_id: this.account,
        key_word: query
      }
      const fnCallback = (data) => {
        isArray(data) && this.canning && (this.autoData = data)
      }
      this.canning = true
      if (this.action) {
        params = Object.assign(params, { action_days: this.action_days, action_scene: this.postActionScene })
        getCategoryAction(params).then(fnCallback)
      } else getCagegoryInterest(params).then(fnCallback)
    },
    cannelHandle(type) {
      this.canning = false
      if (type === 'gategory') this.autoData = []
      else this.completeData = []
    },
    handleMore() {
      this.queryKeyword({
        id: this.params.id,
        name: this.queryWord,
        tag_type: 'CATEGORY'
      })
    },
    // 批量加入关键词
    selectKeyword(items) {
      if (!isArray(items)) return
      const invaild = this.max - this.actions.length
      const word_ids = JSON.parse(JSON.stringify(this.words)).map((ret) => ret.id)
      const push_items = items
        .filter((ret, id) => id < invaild && !word_ids.includes(ret.id))
        .map((ret) => Object.assign(ret, { _time: Date.now() }))
      this.words.push(...push_items)
    },
    // 删除已选
    delTag(item) {
      const { id, type } = item
      if (type === 'CATEGORY') {
        const data = getKeyOfData(this.categories, 'key', id)
        const delCheck = (item) => {
          if (item.children && item.children.length) {
            item.children.forEach((ret) => {
              delCheck(ret)
            })
          }
          this.$set(item, 'check', false)
        }
        delCheck(data)
      } else {
        const idx = this.words.findIndex((ret) => ret.id === id)
        if (idx > -1) this.words.splice(idx, 1)
      }
    },
    // 清空全部
    clearTag() {
      clearTagOfData(this.categories, this)
      this.words = []
    },
    // 打开导入弹窗
    uploadBetch() {
      this.$Spin.show()
      if (this.action) {
        // 行为类目查询
        getActionCategory({ ad_account_id: this.account, action_days: 30, action_scene: 'E-COMMERCE,NEWS,APP' }).then((data) => {
          if (data) {
            this.$Spin.hide()
            const categories = concat(this.categories, [])
            this.betchSource = [...categories, ...data]
            this.betchModel = true
          }
        })
      } else {
        // 兴趣类目查询
        getInterestCategory({ ad_account_id: this.account }).then((data) => {
          if (data) {
            this.$Spin.hide()
            const categories = concat(this.categories, [])
            this.betchSource = [...categories, ...data]
            this.betchModel = true
          }
        })
      }
    },
    betchAddWords(val) {
      const cates = val.filter((ret) => ret.type === 'CATEGORY')
      const words = val.filter((ret) => ret.type === 'KEYWORD')
      cates.forEach((ret) => {
        const data = getKeyOfData(this.categories, 'id', ret.id)
        const addCheck = (item) => {
          if (item.children && item.children.length) {
            item.children.forEach((ret) => {
              addCheck(ret)
            })
          }
          this.$set(item, 'check', true)
        }
        addCheck(data)
      })
      words.forEach((ret) => {
        const index = this.keywords.findIndex((met) => met.name === ret.name)
        if (index > -1) this.$set(this.keywords[index], 'check', true)
        else this.words.push(Object.assign({}, ret, { check: true }))
      })
      this.betchModel = false
    }
  },
  data() {
    return {
      canning: null, // 取消状态
      loading: null, // 数据请求状态
      words: [], // 已选关键词
      categories: [], // 类目数据
      recommons: [], // 相关推荐结果
      queryWord: '', // 相关推荐词
      quering: null, // 请求关键词状态
      keyword: '', // 添加关键词
      keywords: [], // 关键词数据
      completeData: [], // 关键词下拉模糊搜索数据源
      autoData: [], // 类目下拉数据源
      tagType: 'category',
      betchModel: null, // 批量导入组件显示
      betchSource: [], // 批量导入的数据源
      days: DAYS,
      scenes: SCENE
    }
  },
  watch: {
    actions: {
      handler(nVal) {
        this.$emit('input', nVal)
      },
      deep: true
    },
    account() {
      this.loading = false
      this.proLoadData()
    },
    action_scene: {
      handler(nVal) {
        this.loading = false
        this.proLoadData()
      },
      deep: true
    },
    action_days() {
      this.loading = false
      this.proLoadData()
    }
  },
  created() {
    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-action-interest {
  position: relative;

  .c-action-line {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    span {
      padding: 0 6px;

      &:first-child {
        padding-left: 0;
      }
    }
  }

  .c-action-content {
    .c-action-category {
      border: solid 1px #dee4f5;

      ::v-deep .c-tabs-content {
        padding: 0 8px 10px 8px;
      }

      ::v-deep .c-action-search {
        margin-bottom: 16px;
      }
    }
  }

  ::v-deep .ivu-tabs-bar {
    margin-bottom: 12px !important;
  }

  ::v-deep .el-input {
    .el-input__inner,
    .el-input__icon {
      height: 30px;
      line-height: 30px;
    }
  }

  ::v-deep .ivu-tabs-nav {
    margin-left: 10px;

    .ivu-tabs-tab {
      padding: 15px 16px;
    }
  }
}
</style>
